// Import the functions you need from the SDKs you need
import { initializeApp , getApps, getApp} from "firebase/app";
import { getFirestore } from 'firebase/firestore';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_PRODUCT_KEY,
 
    authDomain: "products-f0533.firebaseapp.com",
    projectId: "products-f0533",
    storageBucket: "products-f0533.firebasestorage.app",
    messagingSenderId: "960412872137",
    appId: process.env.REACT_APP_FIREBASE_PRODUCT_ID,
   
};

// Initialize Firebase
// const app = getApps().length ? getApp() : initializeApp(firebaseConfig);

// export const productDb = getFirestore(app);



// Check if the app is already initialized
const productApp =
  getApps().find(app => app.name === 'adult-apparel') ||
  initializeApp(firebaseConfig, 'adult-apparel');

// console.log('Connected to Firebase project:', productApp.name);

// const analytics = getAnalytics(orderApp);
const productDb = getFirestore(productApp);

export { productDb };